import { priceList } from '@/constant/priceList'
import { useFormConfig } from './useFormConfig'
import { usePriceCalculations } from './usePriceCalculations'
import { useScrollNavigation } from './useScrollNavigation'

export function useProjectEstimator () {
  const { form, sections, sectionFields } = useFormConfig()
  const {
    calculateWebsitePrice,
    calculateDesignPrice,
    calculateVideoPrice,
    websiteMaintenance,
    designSocialMediaService,
    videoServices,
    totalPrice,
    yearlyTotal,
    monthlyTotal,
    weeklyTotal,
  } = usePriceCalculations(form.value)
  const { formContainer, activeSection, setSectionRef, scrollToSection } = useScrollNavigation(sections)

  return {
    form,
    sections,
    sectionFields,
    formContainer,
    activeSection,
    setSectionRef,
    calculateWebsitePrice,
    calculateDesignPrice,
    calculateVideoPrice,
    websiteMaintenance,
    designSocialMediaService,
    videoServices,
    totalPrice,
    yearlyTotal,
    monthlyTotal,
    weeklyTotal,
    scrollToSection,
    priceList,
  }
}
